import { render, staticRenderFns } from "./now-monitor.vue?vue&type=template&id=a6a7148a&scoped=true"
import script from "./now-monitor.vue?vue&type=script&lang=js"
export * from "./now-monitor.vue?vue&type=script&lang=js"
import style0 from "./now-monitor.vue?vue&type=style&index=0&id=a6a7148a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6a7148a",
  null
  
)

export default component.exports